import { Component, OnInit, NgZone, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ChronologyService } from '@services/chronology.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SearchService } from '@services/search.service';
import * as _ from 'lodash';
@Component({
  selector: 'app-ceducation',
  templateUrl: './ceducation.component.html',
  styleUrls: ['./ceducation.component.sass']
})
export class CeducationComponent implements OnInit {
  suggestions$: any = [];
  error: any = { name: '', endTime: '', startTime: '' };
  component = "";
  isLoading = false;
  btn_process = false;
  appCreateForm: FormGroup;
  isSubmitted = false;
  search_txt = "";
  suggestions: any = [];
  meta = "education";
  college: any = [];
  application = "chronology";
  maxDate:Date;
  constructor(private _searchService: SearchService, private fb: FormBuilder, private _chronology: ChronologyService, private _global: GlobalService, private router: Router) {
    this.component = this._global.COMPONENTS_SMN;
    this.maxDate = new Date();
    this.appCreateForm = this.fb.group({
      name: ['',[Validators.required]],
      address: ['', [Validators.required, Validators.minLength(6)]],
      degree: [],
      website: [],
      startTime: ['', [Validators.required]],
      endTime: ['', [Validators.required]]
    });
  }

  ngOnInit() {

  }
  get formField() {
    return this.appCreateForm.controls;
  }
  selectCollege(item) {
    this.college = item;
  }
  search(text) {
    this.isLoading = true;
    let pa = {
      component: this.component,
      application: 'college',
      suggestText: text,
      start: 0,
      rows: 100
    };
    this._searchService.suggest(pa).subscribe(
      data => {
        this.suggestions = [];
        this.isLoading = false;
        if (!_.isEmpty(this._global.getVal(data, 'response', []))) {
          let result = this._global.getVal(data, 'response', []);
          Object.entries(result).forEach(([key, value]) => {
            this.suggestions.push({ value: value['doc'], name: value['doc']["name"], id: value['doc']["id"] });
          });

        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });

  }
  save() {
    this.isSubmitted = true;
    if (!this.appCreateForm.invalid) {
      this.error = { name: '', endTime: '', startTime: '' };
      let r = {};
      let p = this._global.paramsRemoveNull(this.appCreateForm.value);
      let metaData = {
        address: p['address'],
        name: this._global.getVal(this.college,'name',''),
        degree: p['degree'],
        website: p['website']
      };
      this.btn_process = true;
      r['component'] = this.component,
        r['application'] = this.application;
      r['meta'] = this.meta;
      r['name'] =  this._global.getVal(this.college,'name','');
      r['mediaType'] = 'member';
      r['mediaId'] = this._global.getSessionVal('id');
      r['latitude'] = "";
      r['longitude'] = "";
      r['timeZone'] = "EST";
      r['logo'] = "";
      r['metadata'] = JSON.stringify(metaData);
      if (p.startTime) {
        r['startTime'] = new Date(p['startTime']).getTime();
      }
      if (p.endTime) {
        r['endTime'] = new Date(p['endTime']).getTime();
      }
      this._chronology.create(r, this.meta).subscribe(
        data => {

          let severity = 'success';
          let message = '';
          if (this._global.getVal(data, 'status', '') == 1) {
            message = this._global.getVal(data, 'message.info', '');
            this._global.showMessage({ type: severity, message: message });
            this.router.navigate(['/my/' + this.meta]);
          } else {
            console.log("errrrrr")
            this.btn_process = false;
            message = this._global.getVal(data, 'message.error', '');
            severity = 'warning';
            for (let key in data["errors"]) {
              this.error[key] = this._global.getVal(data, 'errors.' + key + '.message', '');
            }
            this._global.showMessage({ type: severity, message: message });
          }
          console.log("errrrrr",this.error)
        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    }

  }
}
